import React, { useContext } from 'react';
import ReactDom from 'react-dom';

import { Context } from '@store/store';

import { StyledLoginModal } from './login-modal.styles';

import CloseButton from './close-button';

const LoginModal = () => {
  const [state, dispatch] = useContext(Context);

  return state.isUserLoggedIn || state.efedNoAuth
    ? null
    : ReactDom.createPortal(
        <StyledLoginModal
          isWobble={state.isLoginModalWobbled}
          onAnimationEnd={() =>
            dispatch({ type: 'WOBBLE_LOGIN_MODAL', payload: false })
          }
          isVisible={state.isLoginModalVisible}
        >
          <CloseButton
            onClick={() => {
              dispatch({
                type: 'TOGGLE_LOGIN_MODAL_VISIBILITY',
                payload: false,
              });
            }}
          />
          <p>
            <a href="/login">Войдите в систему</a>, чтобы разблокировать все
            функции просмотрщика
          </p>
        </StyledLoginModal>,
        document.getElementById('modal'),
      );
};

export default LoginModal;
